import { Divider } from 'antd'
import React from 'react'
import ScoreTable from './ScoreTable'
import DashboardComponent from './Dashboard'

export default function StudentDashboard({ selectedTerm, user }) {
    return <><Divider>Kết quả học tập</ Divider>
    <ScoreTable selectedTerm={selectedTerm} user={user} />
    <Divider>Thống kê bài tập</ Divider>
    <DashboardComponent selectedTerm={selectedTerm} user={user} /></>
}
